// extracted by mini-css-extract-plugin
export default {"big-numbers-container":"SimulationResultBigNumbers_big-numbers-container__jtcuk"};